(function () {
  'use strict';

  function triggerTemplate() {
    return document.querySelector('.hktqv_Trigger');
  }

  function ensureHktTrigger(wrap, productUrl) {
    if (!wrap || !productUrl) return null;

    var host = wrap.querySelector('.pdp-compare__qv-host') || wrap;
    var quickView = host.querySelector('.hktqv_Trigger__QuickView');
    if (quickView) return quickView;

    var template = triggerTemplate();
    if (!template) return null;

    var clone = template.cloneNode(true);
    clone.style.display = 'none';
    clone.setAttribute('data-url', productUrl);
    host.appendChild(clone);
    document.dispatchEvent(new Event('DOMContentLoaded'));
    return host.querySelector('.hktqv_Trigger__QuickView');
  }

  function initCompareTriggers() {
    document.querySelectorAll('.pdp-compare__name-wrap').forEach(function (wrap) {
      var btn = wrap.querySelector('.pdp-compare__atc');
      if (!btn) return;
      ensureHktTrigger(wrap, btn.getAttribute('data-product-url'));
    });
  }

  function openQuickView(btn) {
    var wrap = btn.closest('.pdp-compare__name-wrap');
    var url = btn.getAttribute('data-product-url');
    var quickView = ensureHktTrigger(wrap, url);
    if (quickView) {
      quickView.click();
      return true;
    }
    return false;
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.pdp-compare__atc');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      if (openQuickView(btn)) return;

      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (openQuickView(btn) || tries >= 20) {
          clearInterval(timer);
        }
      }, 200);
    },
    true
  );

  function boot() {
    if (triggerTemplate()) {
      initCompareTriggers();
      return;
    }

    var waits = 0;
    var timer = setInterval(function () {
      waits += 1;
      if (triggerTemplate()) {
        clearInterval(timer);
        initCompareTriggers();
      } else if (waits >= 30) {
        clearInterval(timer);
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
